import { render, staticRenderFns } from "./coursesHome.vue?vue&type=template&id=424c7c9c&scoped=true"
import script from "./coursesHome.vue?vue&type=script&lang=ts"
export * from "./coursesHome.vue?vue&type=script&lang=ts"
import style0 from "./coursesHome.vue?vue&type=style&index=0&id=424c7c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c7c9c",
  null
  
)

export default component.exports